// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Container} from '../container/Container'
import {Icon} from '../icon/Icon'

@Component({
    name: 'NavigationBar',
    components: {
        Container,
        Icon,
    },
    mixins: [
        template,
    ]
})
export class NavigationBar extends Vue {

    public currentScroll: number = 0

    public isMobile = false
    public isNavigationBarVisibleInternal = false

    public isSticky: boolean = false

    @Prop({default: false})
    public goToTop!: boolean

    @Prop({default: false})
    public isNavigationBarVisible!: boolean

    @Watch('isNavigationBarVisible')
    public watchIsNavigationBarVisible(isNavigationBarVisible, oldIsNavigationBarVisible) {

        if (isNavigationBarVisible != this.isNavigationBarVisibleInternal) {
            this.isNavigationBarVisibleInternal = isNavigationBarVisible
        }
    }

    public $refs!: {
        navigation_bar: HTMLElement
        navigation_items: HTMLElement
    }

    public created () {

        window.addEventListener('scroll', this.handleScroll)
        window.addEventListener('resize', this.handleResize)
        window.addEventListener('click', this.handleWindowClick)

        this.isNavigationBarVisibleInternal = this.isNavigationBarVisible
    }

    public mounted() {
        this.handleResize(undefined)
        this.handleScroll(undefined)
    }

    public destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('click', this.handleWindowClick)
    }

    public handleScroll(e) {

        this.currentScroll = document.documentElement!.scrollTop || document.body.scrollTop

        const headerElement = <HTMLElement>document.querySelector(`.${this.$appPrefix}-header`)

        let navigationBarTop = 0;

        if (headerElement && headerElement.className.includes(`--sticky`)) {
            navigationBarTop += headerElement.offsetHeight
        }

        if ((this.$el.getBoundingClientRect().top - navigationBarTop) <= 0) {

            this.isSticky = true

            this.$refs.navigation_bar.style.top = navigationBarTop + 'px'
        } else {
            this.isSticky = false
            this.$refs.navigation_bar.style.top = ''
        }

        // Max height of The navigation bar items on mobile
        if(this.isMobile) {
            navigationBarTop += this.$refs.navigation_bar.offsetHeight

            const fixedFooterElement = <HTMLElement>document.querySelector(`.${this.$appPrefix}-fixed-footer`)

            if (fixedFooterElement) {
                navigationBarTop += fixedFooterElement.offsetHeight
            }

            const windowHeight = document.documentElement!.clientHeight || document.body.clientHeight

            this.$refs.navigation_items.style.maxHeight = (windowHeight - navigationBarTop) + 'px'
        } else {
            this.$refs.navigation_items.style.maxHeight = ''
        }
    }

    public handleResize(e?: any) {
        const windowWidth = document.documentElement!.clientWidth || document.body.clientWidth

        this.isMobile = windowWidth < 768
    }

    public handleWindowClick(e: any) {

        if (e.target.contains(this.$refs.navigation_bar) || !this.$refs.navigation_bar.contains(e.target)) {
            this.isNavigationBarVisibleInternal = false
            this.$emit('update:isNavigationBarVisible', false)
        }
    }

    public handleScrollToTop(e) {

        this.isNavigationBarVisibleInternal = false
        this.$emit('update:isNavigationBarVisible', false)

        this.$nextTick(() => {

            const doc = document.documentElement

            const scrollStep = -window.scrollY / (1000 / 15)

            const interval = setInterval(() => {


                if ( window.scrollY != 0 ) {
                    window.scrollBy( 0, scrollStep )
                } else {
                    clearInterval(interval)
                }

            }, 1)
        });
    }

    public handleToggleMenu(e: Event) {
        this.isNavigationBarVisibleInternal = !this.isNavigationBarVisibleInternal
        this.$emit('update:isNavigationBarVisible', this.isNavigationBarVisibleInternal)
    }
}